import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MdEmail, MdMobileFriendly } from 'react-icons/md'; // Material Design email icon
import { MdVisibility } from 'react-icons/md'; // Material Design email icon
import { MdVisibilityOff } from 'react-icons/md'; // Material Design email icon
import { MdLock } from 'react-icons/md'; // Material Design email icon
import { MdPerson } from 'react-icons/md'; // Material Design email icon
import { Commet } from 'react-loading-indicators';

const url = "http://localhost:8080/api/";
function TranslatorSignUp1() {
    useEffect(()=>{
        localStorage.clear();
        sessionStorage.clear()
    },[])


    const [language, setLanguage] = useState(() => {
        const languageNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return languageNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setChecked(false);
        setOpen(false);
    };

    const handleAgree = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [translatorSignupDetails, setTranslatorSignupDetails] = useState(
        {
            name: '',
            email: '',
            password: '',
            confirmPassword: '',
            mobileNumber: '',
        }
    )

    const [errors, setErrors] = useState(
        {
            noEmail: false,
            invalidEmail: false,
            noPassword: false,
            passwordsNotMatch: false,
            noName: false,
            invalidName: false,
            noMobileNumber: false,
            noValidMobileNumber: false,
        }
    )

    const [checked, setChecked] = useState(false);

    const [open2, setOpen2] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleText, setIsVisibleText] = useState(true);

    const [isVisible2, setIsVisible2] = useState(false);
    const [isVisibleText2, setIsVisibleText2] = useState(true);

    const handleVisiblityClick = () => {
        setIsVisible(!isVisible);
        if (!isVisible && translatorSignupDetails.password.length > 0) {
            setIsVisibleText(true);
        } else if (isVisible && translatorSignupDetails.password.length > 0) {
            setIsVisibleText(false);
        }
    }

    const handleVisiblityClick2 = () => {
        setIsVisible2(!isVisible2);
        if (!isVisible2 && translatorSignupDetails.password.length > 0) {
            setIsVisibleText2(true);
        } else if (isVisible2 && translatorSignupDetails.password.length > 0) {
            setIsVisibleText2(false);
        }
    }

    const [passwordStatus, setPasswordStatus] = useState({
        weak: false,
        medium: false,
        strong: false
    })

    const errorMessages =
        [
            '',
            t('t60'),
            t('t61'),
            t('t62'),
            t('t63'),
            t('t64'),
        ]

    const [errorMessageNumber, setErrorMessageNumber] = useState(0)

    const regexPatterns = [
        /^.{1,7}$/,  // weak password
        /^(?:[a-z]{8,}|[A-Z]{8,}|[0-9]{8,}|[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,})$/,  // medium password
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#*$%^&+=]).{8,}$/,  // strong password
        /(?=.*[A-Z])/,  // contains at least 1 uppercase letter
        /(?=.*[a-z])/,  // contains at least 1 lowercase letter
        /(?=.*[0-9])/,  // contains at least 1 numeric digit
        /(?=.*[!@#*$%^&+=])/,  // contains at least 1 special character
        /^.{8,}$/,  // password length greater than 8 characters
    ];


    useEffect(()=>{
        localStorage.removeItem('translatorsignup1')
    },[])

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('email is already taken')) {
            setError(t('t92'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        navigate('/translatorpersonaldetails')
    };

    const handleContinue = () => {

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const nameRegex = /^[^\d]*$/;
        let newErrors = {};

        newErrors.noEmail = !translatorSignupDetails.email;
        newErrors.noPassword = !translatorSignupDetails.password;
        newErrors.noName = !translatorSignupDetails.name;
        newErrors.noMobileNumber = !translatorSignupDetails.mobileNumber;

        const mobileRegex = /^07\d{8}$/;

        if (translatorSignupDetails.mobileNumber && !mobileRegex.test(translatorSignupDetails.mobileNumber)) {
            newErrors.noValidMobileNumber = true;
        } else {
            newErrors.noValidMobileNumber = false;
        }

        if (translatorSignupDetails.password && (translatorSignupDetails.confirmPassword) !== (translatorSignupDetails.password)) {
            newErrors.passwordsNotMatch = true;
        } else {
            newErrors.passwordsNotMatch = false;
        }

        if ((translatorSignupDetails.email) && !emailRegex.test(translatorSignupDetails.email)) {
            newErrors.invalidEmail = true;
        } else {
            newErrors.invalidEmail = false;
        }

        if ((translatorSignupDetails.name) && !nameRegex.test(translatorSignupDetails.name)) {
            newErrors.invalidName = true;
        } else {
            newErrors.invalidName = false;
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        localStorage.setItem('translatorsignup1',JSON.stringify(translatorSignupDetails));
        navigate('/translatorbankaccountdetails')
    }

    return (
        <div className={`${i18n.language==="en"?"font-urban":(i18n.language==="si"?"font-noto":"font-mukta")}  bg-bgImg md:bg-bglarge bg-no-repeat bg-cover min-h-screen w-screen flex flex-col justify-center pl-[30px] pr-[30px] md:items-center`}>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala"?"සිංහල":(language === "Tamil"?"தமிழ்":language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className='flex flex-col justify-center h-full sm:w-full sm:w-full md:w-[400px] lg:w-[500px] xl:w-[500px]  2xl:w-[500px] mt-[10px]'>
                <img src="/images/logo.svg" className="h-[150px]" alt='logo' />
                <p className="text-center text-[30px] mt-[10px]">{t('t1')}</p>
                <p className='mt-[10px] text-[16px] font-bold text-[#FDC50C]'>{t('t360')}</p>
                <div className="items-center mt-[10px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdPerson size="24px" color="#8189B0" />
                    <input type="text" name="name" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t27')}
                        onChange={(e) => {
                            setTranslatorSignupDetails((prevState) => ({
                                ...prevState, name: e.target.value
                            }))
                        }}
                    />
                </div>
                {errors.noName &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t29')}</p>
                }
                {errors.invalidName &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t28')}</p>
                }

                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdEmail size="24px" color="#8189B0" />
                    <input type="text" name="email" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t14')}
                        onChange={(e) => {
                            setTranslatorSignupDetails((prevState) => ({
                                ...prevState, email: e.target.value.toLowerCase()
                            }))
                        }}
                    />
                </div>
                {errors.noEmail &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t15')}</p>
                }
                {errors.invalidEmail &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t16')}</p>
                }

                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdLock size="26px" color="#8189B0" />
                    <input
                        type={isVisibleText ? "text" : "password"}
                        name="password"
                        className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 text-[15px] ${isVisibleText ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#8189B0] focus:outline focus:outline-0`}
                        placeholder={t('t17')}
                        value={translatorSignupDetails.password}
                        onChange={(e) => {

                            const inputValue = e.target.value.replace(/\s+/g, '').trim();
                            if (inputValue !== "") {
                                setErrors((prev) => ({ ...prev, noPassword: false }));
                                if (regexPatterns[2].test(inputValue)) {
                                    setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: true }));

                                } else if (regexPatterns[1].test(inputValue)) {
                                    setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                } else if (regexPatterns[0].test(inputValue)) {
                                    setPasswordStatus((prev) => ({ ...prev, medium: false, weak: true, strong: false }));

                                } else {
                                    setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                }
                            } else {
                                setErrors((prev) => ({ ...prev, noPassword: false }));
                                setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: false }));
                            }

                            if (inputValue !== '') {
                                if (!regexPatterns[3].test(inputValue)) {
                                    setErrorMessageNumber(1)
                                } else if (!regexPatterns[4].test(inputValue)) {
                                    setErrorMessageNumber(2)
                                } else if (!regexPatterns[5].test(inputValue)) {
                                    setErrorMessageNumber(3)
                                } else if (!regexPatterns[6].test(inputValue)) {
                                    setErrorMessageNumber(4)
                                } else if (!regexPatterns[7].test(inputValue)) {
                                    setErrorMessageNumber(5)
                                } else {
                                    setErrorMessageNumber(0)
                                }
                            } else {
                                setErrorMessageNumber(0)
                            }

                            setTranslatorSignupDetails((prevState) => ({
                                ...prevState, password: inputValue
                            }));
                            if (!isVisible && inputValue.length > 0) {
                                setIsVisibleText(false);
                            } else {
                                setIsVisibleText(true);
                            }
                        }}
                    />
                    {
                        isVisible ? <MdVisibilityOff onClick={handleVisiblityClick} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick} size="24px" color="#8189B0" />
                    }
                </div>

                {errors.noPassword &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t18')}</p>
                }

                {passwordStatus.weak && <p className='text-black text-[12px] mt-[5px] '>{t('t65')}<span className='text-[#fc0000] font-bold'>{t('t66')}</span></p>
                }
                {passwordStatus.medium && <p className='text-black text-[12px] mt-[5px]'>{t('t65')}<span className='text-[#fc8600] font-bold'>{t('t67')}</span></p>
                }
                {passwordStatus.strong && <p className='text-black text-[12px] mt-[5px]'>{t('t65')}<span className='text-[#099509] font-bold'>{t('t68')}</span></p>
                }

                {errorMessageNumber !== 0 && <p className='text-[#ff0000] text-[12px] mt-[5px] '>{errorMessages[errorMessageNumber]}</p>}

                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdLock size="26px" color="#8189B0" />
                    <input type={isVisibleText2 ? "text" : "password"}
                        name="password_confirm"
                        className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 text-[15px] ${isVisibleText2 ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#8189B0] focus:outline focus:outline-0`}
                        placeholder={t('t30')}
                        value={translatorSignupDetails.confirmPassword}
                        onChange={(e) => {
                            const inputValue = e.target.value.replace(/\s+/g, '').trim();
                            setTranslatorSignupDetails((prevState) => ({
                                ...prevState, confirmPassword: inputValue
                            }));
                            if (!isVisible2 && inputValue.length > 0) {
                                setIsVisibleText2(false);
                            } else {
                                setIsVisibleText2(true);
                            }
                        }}
                    />
                    {
                        isVisible2 ? <MdVisibilityOff onClick={handleVisiblityClick2} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick2} size="24px" color="#8189B0" />
                    }
                </div>
                {errors.passwordsNotMatch &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t26')}</p>
                }
                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                    <MdMobileFriendly size="24px" color="#8189B0" />
                    <input type="text" name="mobile" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t57')}
                        onChange={(e) => {
                            setTranslatorSignupDetails((prevState) => ({
                                ...prevState, mobileNumber: e.target.value
                            }))
                        }}
                    />
                </div>
                {errors.noMobileNumber &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t58')}</p>
                }
                {errors.noValidMobileNumber &&
                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t59')}</p>
                }


                {/* <button onClick={handleContinue} className="text-[18px] mt-[15px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t52')}</button> */}
                <button onClick={handleContinue} disabled={isLoading} className="text-[18px] mt-[15px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">
                    {isLoading ? (
                        <div className="items-center justify-center flex">
                            <div className='w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin'></div>
                        </div>
                    ) : (
                        t('t7')
                    )}
                </button>
                <p className="text-black text-[15px] text-center mt-[10px] font-bold mb-[20px]">{t('t8_2')} <span onClick={() => (navigate('/loginas'))} className="text-[#FDC50C] hover:cursor-pointer hover:underline">{t('t25')}</span></p>



                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        {t('t53')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <DialogContentText
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            {t('t49')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleClose}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t51')}
                        </Button>
                        <Button
                            onClick={handleAgree}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t50')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={open2}
                    onClose={handleClose2}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogContent className="bg-[#FFF6DA]">
                        {!isLoading &&
                            <DialogContent
                                id="custom-dialog-description"
                                className="text-gray-600 text-md mt-2"
                            >
                                <div className='flex flex-col justify-center items-center text-center'>
                                    <img src='/images/success.svg' alt='success' />
                                    <div className='mt-[30px]'>{t('t54')}</div>
                                </div>
                            </DialogContent>
                        }

                    </DialogContent>
                    <DialogActions
                        style={{
                            backgroundColor: '#FFF6DA',
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <Button
                            onClick={() => navigate('/loginas')}
                            style={{
                                backgroundColor: '#F2AC0E',
                                color: 'white',
                                padding: '10px 20px', // px-4 py-2
                                borderRadius: '0.375rem', // rounded-md
                                fontWeight: 'bold',
                            }}
                        >
                            {t('t7')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openError}
                    onClose={handleCloseError}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        {t('t95')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <DialogContentText
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            {error}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleCloseError}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t96')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
}

export default TranslatorSignUp1;